import React from 'react';
import ActivityInscription from "./ActivitySubscription";
import { BrowserRouter as Router } from 'react-router-dom'

const App: React.FC = () => {
  return (
    // @ts-ignore
    <Router basename="/embed/v1.0">
      <React.Fragment>
        <ActivityInscription />
      </React.Fragment>
    </Router>
  );
};

export default App;
